import { Location } from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DefaultComponent} from "../../shared/components/default.component";
import {IonModal, LoadingController, ToastController} from "@ionic/angular";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthenticationService} from "../../shared/_services/authentication.service";
import {SharedRoutesService} from "../../shared/_services/shared-routes.service";
import {delay} from "rxjs/operators";

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.page.html',
  styleUrls: ['./forgot.page.scss'],
})
export class ForgotPage extends DefaultComponent implements OnInit {
  @ViewChild(IonModal) modal: IonModal;
  isLoading = false;
  recoverForm: FormGroup;
  public showErrors: boolean;


  constructor(
      private fb: FormBuilder,
      private loadingCtrl: LoadingController,
      private authenticationService: AuthenticationService,
      router: Router,
      activatedRoute: ActivatedRoute,
      sharedRoutesService: SharedRoutesService,
      toastController: ToastController,


  ) {
    super(router, activatedRoute, sharedRoutesService,toastController);
  }



  ngOnInit() {
    this.recoverForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  onRecoverClick() {
    this.isLoading = true;
    const queryParams = this.recoverForm.value;

    this.authenticationService.forgotPassword(queryParams).subscribe(
        (response) => {
          this.isLoading = false;
          this.presentErrorToast("Password recovery email sent");
          // Navigate after 2 seconds
          setTimeout(() => {
            this.router.navigate(['/authentication/login']);
          }, 2000);
        },
        (error) => {
          this.isLoading = false;
          this.showErrors = true;
          this.presentErrorToast(error.error.message);
        }
    );
  }





}
